import ExchangeRatesView from '../ExchangeRatesView.vue'
import ExchangeRateList from '../Pages/ExchangeRateList.vue'

// DEF-ADM-029 — mantenedor de tipos de cambio. Vive en Administracion: es
// configuracion global, no una operacion dentro de una ciudad.
//
// Cuelga de ExchangeRatesView por lo mismo que el dashboard: ese padre es el
// que aporta <page-base>, o sea la barra lateral y la cabecera.
const routes = [
  {
    path: '/tipos-de-cambio',
    component: ExchangeRatesView,
    name: 'exchange-rates',
    children: [
      {
        path: '',
        name: 'exchange-rate-list',
        component: ExchangeRateList,
        meta: { requiresAuth: true }
      }
    ]
  }
]

export default routes
